/**
 * Optimistic training upload receipt for the period between a successful POST
 * and canonical worker dashboard status reconciliation.
 *
 * Document slots use dashboard.missing_documents. Training certificates do not,
 * so sharing the missing-doc cleanup discarded their receipt immediately.
 */
export const REVIEW_CONFIRMED_TRAINING_STATUSES = new Set([
  'awaiting_review', 'processing', 'completed', 'verified',
]);

export function reconcileTrainingUploadReceipts(receipts = {}, trainings = []) {
  const statusByCode = new Map(
    (Array.isArray(trainings) ? trainings : []).map(item => [
      String(item?.id || item?.code || '').trim(),
      String(item?.status || '').trim().toLowerCase(),
    ])
  );
  let changed = false;
  const next = {};
  Object.entries(receipts || {}).forEach(([requirement, submittedAt]) => {
    const code = requirement.replace(/^training_/, '').replace(/_(renewal|replace)$/, '');
    // Keep the submitted receipt while the dashboard still shows old
    // missing/expired/rejected state. Release when canonical evidence truth
    // acknowledges review/verification, so a later rejection can be actioned.
    if (REVIEW_CONFIRMED_TRAINING_STATUSES.has(statusByCode.get(code))) {
      changed = true;
    } else {
      next[requirement] = submittedAt;
    }
  });
  return changed ? next : receipts;
}
